module.exports = __webpack_public_path__ + "img/June 22-1.4dfa0f3.png";